// extracted by mini-css-extract-plugin
export default {"card":"AnimatedCard_card__zLTiJ"};